import React from "react"
import PropTypes from "prop-types"

import WhoCanContactMeContainer from '../match_sections/WhoCanContactMeContainer';
import ProModal from '../app_components/ProModal';
import BlockedUsersSection from './BlockedUsersSection';

class ProSettingWhoCanContactMe extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      proModalType: '',
      proModalOpen: false,
      current_user: {},
      pro_settings: null,
      premiumUser: false,
      idVerification: [],
      filters: {
        gender_id: 1,
        min_age_difference: 18,
        max_age_difference: 152,
        language_ids: [],
        locals_only: '',
      },
      loaded: false
    }

    this.toggleProModal = this.toggleProModal.bind(this)
    this.updateIdVerification = this.updateIdVerification.bind(this)
    this.updateUserSettings = this.updateUserSettings.bind(this)
    this.getCurrentUserInfo = this.getCurrentUserInfo.bind(this)
  }

  componentDidMount() {
    this.getCurrentUserInfo()
  }

  getCurrentUserInfo() {

    $.ajax({
      url: `../match_current_user`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        let filters = {...this.state.filters, locals_only: JSON.parse(data.data.current_user).local_chats_only}
        let learningLanguages = []
        let nativeLanguages = []
        let language_ids = []
        JSON.parse(data.data.languages_users).map((lu) => {
          if(lu.level === 5) {
            nativeLanguages = [...nativeLanguages, lu]
          } else {
            learningLanguages = [...learningLanguages, lu]
            language_ids = [...language_ids, lu.language_id]
          }
        })

        this.setState({
          current_user: JSON.parse(data.data.current_user),
          idVerification: JSON.parse(data.data.id_verification),
          pro_settings: JSON.parse(data.data.pro_settings),
          languages_users: JSON.parse(data.data.languages_users),
          nativeLanguages: nativeLanguages,
          learningLanguages: learningLanguages,
          filters: filters,
          premiumUser: data.data.premium_user,
          loaded: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  toggleProModal(type) {
    this.setState({
      proModalType: type,
      proModalOpen: !this.state.proModalOpen
    })
  }

  updateIdVerification() {
    let data = {
      user: {
        verified_chats_only: !this.state.current_user.verified_chats_only
      }
    }
    $.ajax({
      url: `../update_user`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getCurrentUserInfo()
      },
      catch: (error) => {
        console.log('error')
      }
    })
  }

  updateUserSettings(key, value) {
    let data = {
      user: {
        [key]: value
      }
    }
    $.ajax({
      url: `../update_user`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getCurrentUserInfo()
      },
      catch: (error) => {
        console.log('error')
      }
    })
  }

  render() {
    if(!this.state.loaded) {
      return null
    }
    return(
      <div className="lex-form-page lex-form-page--narrow">
        <header className="lex-form-page__header">
          <h1 className="lex-form-page__title">Who Can Contact Me</h1>
          <p className="lex-form-page__subtitle">
            Choose who can send you Connect requests. You still approve every request, and existing Connections aren't affected by changes here.
          </p>
        </header>
        {this.state.proModalOpen &&<ProModal
          type={this.state.proModalType}
          premiumImage={this.props.premiumImage}
          onClose={() => this.toggleProModal('')}
          />}
        <WhoCanContactMeContainer
          current_user={this.state.current_user}
          idVerification={this.state.idVerification}
          premiumUser={this.state.premiumUser}
          pro_settings={this.state.pro_settings}
          toggleProModal={this.toggleProModal}
          updateIdVerification={this.updateIdVerification}
          updateUserSettings={this.updateUserSettings}
        />
        <BlockedUsersSection
          currentUserId={this.state.current_user.id}
          missingImgUrl={this.props.missingImgUrl}
        />
      </div>
    )
  }

}


export default ProSettingWhoCanContactMe;
